/* ==========================================================================
   VOCAL CHEF — product page. Isolated in its own deferred asset so a throw in
   any section bundle can never kill the gallery, the picker or the buy box.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var $  = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var fmt = function (c) { return (window.VC && window.VC.fmt) ? window.VC.fmt(c) : c; };

  function init(root) {
    var sec = root || $('[data-vc-product]');
    if (!sec || sec.dataset.vcInit) return;
    sec.dataset.vcInit = '1';

    var variants = [];
    var strings = {};
    try { variants = JSON.parse($('[data-vc-variants]', sec).textContent); } catch (e) {}
    try { strings = JSON.parse($('[data-vc-strings]', sec).textContent); } catch (e) {}

    var form      = $('#vc-buy', sec);
    var idInput   = $('[data-vc-variant-id]', sec);
    var priceEl   = $('[data-vc-price]', sec);
    var compareEl = $('[data-vc-compare]', sec);
    var saveEl    = $('[data-vc-save]', sec);
    var noteEl    = $('[data-vc-note]', sec);
    var stockEl   = $('[data-vc-stock]', sec);
    var atc       = $('[data-vc-atc]', sec);
    var atcLabel  = $('[data-vc-atc-label]', sec);
    var mainImg   = $('#pMain', sec);
    var thumbs    = $$('[data-th]', sec);
    var optionRows = $$('[data-vc-option]', sec);
    var flag      = $('.gal-flag', sec);
    var sbarPrice = $('[data-vc-sbar-price]');
    var sbarAdd   = $('[data-vc-sbar-add]');
    var qtyOut    = $('[data-vc-qty-out]', sec);
    var qtyInput  = $('[data-vc-qty-input]', sec);
    var qty = 1;

    /* ---------- gallery ---------- */
    function showThumb(btn) {
      if (!btn || !mainImg) return;
      mainImg.src = btn.getAttribute('data-src');
      if (btn.getAttribute('data-srcset')) mainImg.srcset = btn.getAttribute('data-srcset');
      mainImg.alt = btn.getAttribute('data-alt') || '';
      thumbs.forEach(function (t) { t.classList.toggle('on', t === btn); });
      centreThumb(btn);
    }
    function centreThumb(btn) {
      var rail = btn.parentElement;
      if (!rail || rail.scrollWidth <= rail.clientWidth) return;
      var d = btn.offsetLeft - rail.scrollLeft - (rail.clientWidth - btn.offsetWidth) / 2;
      rail.scrollBy({ left: d, behavior: 'smooth' });
    }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { showThumb(b); }); });
    if (mainImg) {
      mainImg.addEventListener('keydown', function () {});
      sec.addEventListener('keydown', function (e) {
        if (!thumbs.length) return;
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        if (!e.target.closest('.gal')) return;
        var i = thumbs.findIndex(function (t) { return t.classList.contains('on'); });
        if (i < 0) i = 0;
        i = e.key === 'ArrowRight' ? (i + 1) % thumbs.length : (i - 1 + thumbs.length) % thumbs.length;
        showThumb(thumbs[i]);
        thumbs[i].focus();
      });
    }

    /* ---------- variant matching ---------- */
    function selected() {
      return optionRows.map(function (row) {
        var on = $('[aria-pressed="true"]', row) || $('.on', row);
        return on ? on.getAttribute('data-vc-value') : null;
      });
    }
    function matchVariant(sel) {
      return variants.find(function (v) {
        return sel.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }
    function exactVariant(sel) {
      if (sel.some(function (v) { return v === null; })) return null;
      return variants.find(function (v) {
        return sel.every(function (val, i) { return v.options[i] === val; });
      }) || null;
    }

    /* colour column index: the option row whose picker is a swatch row */
    var colourIdx = optionRows.findIndex(function (row) { return !!$('.sw', row); });

    function priceNote(v, sel) {
      if (!noteEl) return;
      /* the note shares its row with the size-guide link — blanking it strands
         that link on a line of its own, so fall back rather than empty it */
      var fallback = noteEl.getAttribute('data-vc-note-fallback') || '';
      if (colourIdx < 0) { noteEl.textContent = fallback; return; }
      var name = sel[colourIdx];
      if (!name) { noteEl.textContent = fallback; return; }
      /* This row used to read "White · Black £15.99" — the colour you have, a
         dot, then a colour you do not and a price. Two colours and one price
         with nothing to say which belongs to which. Shoppers read it as a list
         of what the product comes in, not as an offer, and could not tell what
         the £15.99 was for.

         Say the sentence instead: "Shop Black for £15.99". One colour, one
         price, and a verb that makes the relationship obvious. And since it
         names a thing you might want, make it the control that gets you there
         rather than a label about it. */
      var here = v ? v.price : null;
      var best = null;
      variants.forEach(function (x) {
        if (x.options[colourIdx] === name) return;
        if (!x.available) return;                       /* never offer a dead end */
        if (here !== null && x.price === here) return;  /* nothing to say if it costs the same */
        if (!best || x.price < best.price) best = x;    /* the cheapest way into another colour */
      });

      if (!best) { noteEl.textContent = name; return; }

      var tpl = noteEl.getAttribute('data-vc-note-swap') || '';
      var other = best.options[colourIdx];
      if (!tpl) { noteEl.textContent = name + ' \u00b7 ' + other + ' ' + fmt(best.price); return; }

      noteEl.textContent = '';
      var swap = doc.createElement('button');
      swap.type = 'button';
      swap.className = 'pd-swap';
      swap.setAttribute('data-vc-swap', other);
      swap.textContent = tpl.replace('[colour]', other).replace('[price]', fmt(best.price));
      noteEl.appendChild(swap);
    }

    function paintStock(v, sel, complete) {
      if (!stockEl) return;
      /* stock is per size, so it means nothing until a size is chosen — the
         design keeps this hidden rather than quoting the first variant's count */
      if (!complete) { stockEl.hidden = true; return; }
      if (!v || !v.available || v.inventoryManagement !== 'shopify' || v.inventoryPolicy !== 'deny') {
        stockEl.hidden = true;
        return;
      }
      var n = v.inventoryQuantity;
      if (n == null || n <= 0) { stockEl.hidden = true; return; }
      var lowAt = Number(strings.lowAt || 6);
      stockEl.hidden = false;
      stockEl.classList.toggle('low', n <= lowAt);
      var sizeLabel = sel.filter(Boolean).slice(-1)[0] || '';
      if (sizeLabel.indexOf(' / ') > -1) sizeLabel = sizeLabel.split(' / ')[0];
      var msg = n <= lowAt
        ? String(strings.lowStock || 'Only <b>[n] left</b> in [size]').replace('[n]', n).replace('[size]', sizeLabel)
        : String(strings.inStock || '<b>In stock</b>');
      $('span', stockEl).innerHTML = msg;
    }

    function paint() {
      var sel = selected();
      var v = exactVariant(sel) || matchVariant(sel);
      var complete = !sel.some(function (x) { return x === null; });

      if (v && idInput) idInput.value = v.id;

      if (v && priceEl) priceEl.innerHTML = v.priceHtml;
      if (v && compareEl) {
        var on = v.compare_at_price > v.price;
        compareEl.hidden = !on;
        compareEl.innerHTML = on ? v.compareHtml : '';
        if (saveEl) {
          saveEl.hidden = !on;
          if (on) {
            var diff = v.compare_at_price - v.price;
            var pct = Math.round(diff * 100 / v.compare_at_price);
            saveEl.textContent = (strings.saveLabel || 'Save') + ' ' + fmt(diff) + ' · ' + pct + '%';
          }
        }
      }
      priceNote(v, sel);
      paintStock(v, sel, complete);

      if (atc) {
        /* An unchosen size leaves the button LIVE. Disabling it here made the
           page go quietly dead on a click — the shopper gets no reason. The
           submit guard shakes the size row and names the problem instead, which
           is what the design does. Only a real dead end disables the button. */
        var deadEnd = (v && !v.available) || (complete && !v);
        atc.disabled = !!deadEnd;
        if (atcLabel) {
          atcLabel.textContent = complete && !v ? (strings.unavailable || 'Unavailable')
            : (v && !v.available ? (strings.soldOut || 'Sold out') : (strings.add || 'Add to bag'));
        }
      }
      if (sbarAdd) sbarAdd.disabled = !!((v && !v.available) || (complete && !v));

      /* the bundle builder prices the same product — tell it what is selected,
         or it keeps quoting the variant the page happened to load with */
      doc.dispatchEvent(new CustomEvent('vc:variant', {
        detail: v ? { id: v.id, price: v.price, available: !!v.available, complete: complete }
                  : { id: null, price: null, available: false, complete: complete }
      }));
      if (sbarPrice && v) sbarPrice.innerHTML = fmt(v.price * qty);
      if (flag && v && !v.available) { flag.textContent = strings.soldOut || 'Sold out'; flag.className = 'gal-flag out'; }

      /* swap the gallery to the variant's own media */
      if (v && v.mediaId) {
        var t = thumbs.find(function (x) { return x.getAttribute('data-media-id') === String(v.mediaId); });
        if (t && !t.classList.contains('on')) showThumb(t);
      }
      /* shareable, refresh-safe URL */
      if (v && complete && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    optionRows.forEach(function (row) {
      row.addEventListener('click', function (e) {
        var b = e.target.closest('[data-vc-value]');
        if (!b) return;
        e.preventDefault();
        $$('[data-vc-value]', row).forEach(function (x) {
          x.classList.toggle('on', x === b);
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        var label = $('[data-vc-option-value]', row);
        if (label) label.textContent = b.getAttribute('data-vc-value');
        row.classList.remove('warn');
        paint();
      });
    });

    /* the note's offer is a shortcut to the swatch it names */
    sec.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-vc-swap]');
      if (!sw || colourIdx < 0) return;
      e.preventDefault();
      var row = optionRows[colourIdx];
      if (!row) return;
      var want = sw.getAttribute('data-vc-swap');
      var target = $$('[data-vc-value]', row).filter(function (b) {
        return b.getAttribute('data-vc-value') === want;
      })[0];
      if (target) target.click();
    });

    /* ---------- quantity ---------- */
    $$('[data-vc-qty]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        qty = Math.max(1, Math.min(20, qty + Number(b.getAttribute('data-vc-qty'))));
        if (qtyOut) qtyOut.textContent = qty;
        if (qtyInput) qtyInput.value = qty;
        paint();
      });
    });

    /* ---------- "choose a size first" guard ---------- */
    function missingRow() {
      return optionRows.find(function (row) { return !$('[aria-pressed="true"]', row); });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        var row = missingRow();
        if (!row) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        row.classList.add('warn');
        if (window.VC && window.VC.toast) window.VC.toast(strings.chooseSize || 'Choose an option first', 'error');
        row.scrollIntoView({ block: 'center', behavior: 'smooth' });
        setTimeout(function () { row.classList.remove('warn'); }, 1800);
      }, true);
    }

    /* ---------- sticky mobile bar ---------- */
    var sbar = $('#sbar');
    var buyBox = $('.buy', sec);
    var raf = false;
    function sbarState() {
      raf = false;
      if (!sbar || !buyBox) return;
      var past = buyBox.getBoundingClientRect().bottom < 0;
      sbar.classList.toggle('on', past && !(sbarAdd && sbarAdd.disabled));
    }
    function onScroll() { if (!raf) { raf = true; requestAnimationFrame(sbarState); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    sbarState();

    /* ---------- size & fit dialog ---------- */
    var fitm = $('#fit');
    if (fitm) {
      var lastFit = null;
      function fitOpen(open) {
        if (open) lastFit = doc.activeElement;
        fitm.hidden = !open;
        doc.documentElement.style.overflow = open ? 'hidden' : '';
        if (open) { var c = $('[data-fit-close]', fitm); if (c) c.focus(); }
        else if (lastFit && lastFit.focus) lastFit.focus();
      }
      doc.addEventListener('click', function (e) {
        if (e.target.closest('[data-fit]')) { e.preventDefault(); fitOpen(true); }
        else if (e.target.closest('[data-fit-close]')) { e.preventDefault(); fitOpen(false); }
      });
      doc.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !fitm.hidden) fitOpen(false);
        if (e.key !== 'Tab' || fitm.hidden) return;
        var f = $$('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])', fitm);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }

    paint();
  }

  /* ---------- countdowns ----------
     Offer window and dispatch cut-off, both exactly as the design computes them. */
  function weeklyEnd() {
    /* the upcoming Sunday, 23:59:59 — so the window never shows as expired */
    var d = new Date();
    var end = new Date(d);
    end.setDate(d.getDate() + ((7 - d.getDay()) % 7));
    end.setHours(23, 59, 59, 0);
    if (end <= d) end.setDate(end.getDate() + 7);
    return end.getTime();
  }

  function ticks() {
    $$('[data-vc-countdown]').forEach(function (el) {
      var raw = el.getAttribute('data-vc-countdown');
      var end = raw === 'weekly' ? weeklyEnd() : new Date(raw).getTime();
      if (isNaN(end)) return;
      var ms = end - Date.now();
      if (ms <= 0) { var box = el.closest('.offer'); if (box) box.hidden = true; return; }
      var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24,
          mi = Math.floor(ms / 6e4) % 60, sec = Math.floor(ms / 1e3) % 60;
      /* seconds, and a one-second tick. At minute granularity on a 30s timer the
         clock sat unchanged for up to a minute at a time and read as a picture
         of a countdown rather than a countdown. */
      el.textContent = (d ? d + 'd ' : '') + h + 'h ' + mi + 'm ' + sec + 's';
    });

    $$('[data-vc-dispatch]').forEach(function (el) {
      var cutoff = Number(el.getAttribute('data-cutoff'));
      if (isNaN(cutoff)) cutoff = 14;
      var now = new Date();
      var c = new Date(now);
      c.setHours(cutoff, 0, 0, 0);
      /* before the cut-off on a working day ships today; otherwise roll to the
         next working day, skipping the weekend */
      var sameDay = now < c && now.getDay() > 0 && now.getDay() < 6;
      if (!sameDay) {
        do { c.setDate(c.getDate() + 1); } while (c.getDay() === 0 || c.getDay() === 6);
      }
      var ms = c - now;
      var h = Math.floor(ms / 36e5), mi = Math.floor(ms / 6e4) % 60;
      var tpl = el.getAttribute(sameDay ? 'data-today' : 'data-next') ||
                (sameDay ? 'Order in [t] for dispatch today' : 'Next dispatch in [t]');
      var span = el.querySelector('span');
      if (span) span.innerHTML = tpl.replace('[t]', '<b>' + h + 'h ' + mi + 'm</b>');
      el.hidden = false;
    });
  }

  /* ---------- bundle builder ("complete the uniform") ---------- */
  function initBundle(root) {
    var box = (root || doc).querySelector('[data-vc-bundle]');
    if (!box || box.dataset.vcInit) return;
    box.dataset.vcInit = '1';

    var goal = Number(box.getAttribute('data-goal') || 0);
    var flat = Number(box.getAttribute('data-flat') || 0);
    var lines = $('[data-bd-lines]', box);
    var totalEl = $('[data-bd-total]', box);
    var shipEl = $('[data-bd-ship]', box);
    var saveEl = $('[data-bd-save]', box);
    var addBtn = $('[data-bd-add]', box);
    var ladder = $('[data-bd-ladder]', box.parentNode || doc) || $('[data-bd-ladder]');
    var baseTile = $('[data-bd-base]', box);
    var picked = {};

    /* The page's own product is a tile like any other now, ticked from the
       markup rather than bolted on inside repaint(). Reading the starting state
       off the DOM keeps one source of truth: whatever Liquid rendered as
       pressed is what the builder starts with. */
    $$('[data-bd]', box).forEach(function (b) {
      if (b.getAttribute('aria-pressed') === 'true' && !b.disabled) picked[b.getAttribute('data-bd')] = true;
    });

    function chosen() {
      return $$('[data-bd]', box).filter(function (b) { return picked[b.getAttribute('data-bd')]; });
    }

    doc.addEventListener('vc:variant', function (e) {
      var d = e.detail || {};
      if (!baseTile) return;
      /* Keep the base tile in step with the buy form. An incomplete selection
         leaves it on its opening variant rather than blanking the builder while
         the shopper is still deciding. */
      if (d.id) {
        baseTile.setAttribute('data-vid', d.id);
        baseTile.setAttribute('data-price', d.price);
        var lab = $('[data-bd-variant]', baseTile);
        if (lab) {
          var t = d.title && d.title !== 'Default Title' ? d.title : '';
          lab.textContent = t;
          lab.hidden = !t;
        }
        /* a sold-out pick cannot join the build, so say so rather than adding
           something checkout will refuse */
        var gone = d.available === false;
        baseTile.disabled = gone;
        baseTile.classList.toggle('bd-c--gone', gone);
        if (gone) { picked.base = false; baseTile.classList.remove('on'); baseTile.setAttribute('aria-pressed', 'false'); }
      }
      repaint();
    });
    function repaint() {
      var rows = [];
      chosen().forEach(function (b) {
        rows.push({ title: b.getAttribute('data-title'), price: Number(b.getAttribute('data-price')), id: Number(b.getAttribute('data-vid')) });
      });
      var gross = rows.reduce(function (n, r) { return n + r.price; }, 0);
      /* the multi-buy rung the current basket earns, highest first */
      var rungs = [];
      try { rungs = JSON.parse(box.getAttribute('data-rungs') || '[]'); } catch (e) {}
      var rung = null;
      for (var ri = 0; ri < rungs.length; ri++) {
        if (rows.length >= rungs[ri].n) { rung = rungs[ri]; break; }
      }
      var off = rung ? Math.round(gross * rung.pct / 100) : 0;
      var total = gross - off;
      if (saveEl) {
        saveEl.hidden = !rung;
        if (rung) {
          var lbl = (box.getAttribute('data-save-label') || '[n]-piece discount · [pct]%')
            .replace('[n]', rung.n).replace('[pct]', rung.pct);
          saveEl.innerHTML = '<span>' + lbl + '</span><em>\u2212' + fmt(off) + '</em>';
        }
      }
      lines.innerHTML = rows.length
        ? rows.map(function (r) { return '<li><span>' + r.title + '</span><em>' + fmt(r.price) + '</em></li>'; }).join('')
        : '<li class="dim"><span>' + (box.getAttribute('data-empty') || 'Nothing selected yet') + '</span><em>—</em></li>';
      totalEl.innerHTML = fmt(total);
      var done = goal > 0 && total >= goal;
      shipEl.className = 'bd-ship' + (done ? ' done' : '');
      shipEl.innerHTML = done
        ? '<i class="fa-solid fa-check"></i> ' + (box.getAttribute('data-ship-done') || 'Free UK delivery included')
        : '<i class="fa-solid fa-truck-fast"></i> ' + fmt(Math.max(0, goal - total)) + ' ' + (box.getAttribute('data-ship-more') || 'more for free UK delivery');
      addBtn.innerHTML = (box.getAttribute('data-add-label') || 'Add') + ' ' + rows.length + ' ' +
        (rows.length === 1 ? (box.getAttribute('data-item') || 'item') : (box.getAttribute('data-items') || 'items')) +
        ' <i class="fa-solid fa-arrow-right"></i>';
      addBtn.classList.toggle('is-off', !rows.length);
      addBtn.dataset.rows = JSON.stringify(rows.map(function (r) { return { id: r.id, quantity: 1 }; }));

      /* Light up the rung this build has earned. The ladder is a price list, and
         a price list that answers back cannot be mistaken for a row of tabs. */
      if (ladder) {
        $$('[data-rung]', ladder).forEach(function (li) {
          li.classList.toggle('is-now', Number(li.getAttribute('data-rung')) === (rung ? rung.n : (rows.length ? 1 : 0)));
        });
        var shipLi = $('[data-ship]', ladder);
        if (shipLi) shipLi.classList.toggle('is-now', done);
      }
    }
    function tick(b, k, on) {
      picked[k] = on;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      repaint();
    }

    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bd]');
      if (b) {
        e.preventDefault();
        var k = b.getAttribute('data-bd');
        var label = b.querySelector('[data-bd-variant]');
        var needs = b.hasAttribute('data-needs-pick');

        /* A sized piece has to answer for itself before it can join the build,
           or the builder would quietly commit the shopper to a size they never
           chose. The chooser asks, then ticks. */
        if (needs && !picked[k] && !b.getAttribute('data-vid') && window.VC && window.VC.pick) {
          window.VC.pick({
            url: b.getAttribute('data-pick-url'),
            button: b,
            cta: box.getAttribute('data-pick-cta') || 'Add to build',
            onPick: function (v) {
              b.setAttribute('data-vid', v.id);
              b.setAttribute('data-price', v.price);
              if (label) { label.textContent = v.title; label.hidden = false; }
              tick(b, k, true);
            }
          });
          return;
        }

        /* Un-ticking forgets the variant too, so the tile never sits there
           showing a size with no visible way to change it. */
        if (needs && picked[k]) {
          b.setAttribute('data-vid', '');
          if (label) { label.textContent = ''; label.hidden = true; }
        }
        tick(b, k, !picked[k]);
        return;
      }
      if (e.target.closest('[data-bd-add]')) {
        e.preventDefault();
        var rows = [];
        try { rows = JSON.parse(addBtn.dataset.rows || '[]'); } catch (err) {}
        rows = rows.filter(function (r) { return r.id; });
        if (!rows.length || !window.VC) return;
        window.VC.addToCart(rows, { button: addBtn });
      }
    });
    repaint();
  }

  /* ---------- lazy recommendations ---------- */
  function initRelated(root) {
    var box = (root || doc).querySelector('[data-vc-related]');
    if (!box || box.dataset.vcInit) return;
    box.dataset.vcInit = '1';
    var pid = box.getAttribute('data-product-id');
    var limit = box.getAttribute('data-limit') || 4;
    var sid = box.getAttribute('data-section-id');
    var intent = box.getAttribute('data-intent') || 'related';
    if (!pid || !sid) return;
    var url = (window.VCROUTES && window.VCROUTES.root ? window.VCROUTES.root.replace(/\/$/, '') : '') +
      '/recommendations/products?section_id=' + encodeURIComponent(sid) +
      '&product_id=' + encodeURIComponent(pid) + '&limit=' + limit + '&intent=' + intent;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var tmp = doc.createElement('div');
        tmp.innerHTML = html;
        var grid = tmp.querySelector('[data-vc-related-grid]');
        var target = box.querySelector('[data-vc-related-grid]');
        if (grid && target && grid.children.length) {
          target.innerHTML = grid.innerHTML;
          if (window.VC && window.VC.initReveal) window.VC.initReveal(target);
        }
      })
      .catch(function () {});
  }

  /* ---------------- gallery: stick only while it fits ----------------
     The design pins the gallery to the top of the screen while the buy column
     scrolls past it. That only reads well while the whole gallery — the square
     plus its thumbnail strip — is on screen at once. Shorten the window and it
     is not: a sticky element taller than the viewport locks at its top offset
     and the strip below the fold becomes unreachable for the whole scroll.

     Capping the height instead is what put the strip BEHIND the photograph, and
     shrinking the photograph to make room made it change size every time the
     window did. So measure, and let it stick only when there is room. Below
     that it is an ordinary block: same size, scrolls with the page, no surprise
     when someone drags the window shorter. */
  function galleryFit() {
    var gal = $('.gal');
    if (!gal) return;
    var cs = getComputedStyle(doc.documentElement);
    var offset = (parseFloat(cs.getPropertyValue('--vc-abH')) || 0) +
                 (parseFloat(cs.getPropertyValue('--vc-hdrH')) || 0) + 18;
    /* offsetHeight is unaffected by the class we are about to set, so this
       cannot oscillate between the two states */
    var fits = gal.offsetHeight + offset + 16 <= window.innerHeight;
    gal.classList.toggle('is-sticky', fits);
  }

  var galTimer;
  function galleryFitSoon() {
    clearTimeout(galTimer);
    galTimer = setTimeout(galleryFit, 120);
  }
  window.addEventListener('resize', galleryFitSoon);
  /* the square is sized from an image, so remeasure once it has actually loaded */
  window.addEventListener('load', galleryFit);

  function boot(root) { init(root && root.querySelector ? root.querySelector('[data-vc-product]') : null); initBundle(root); initRelated(root); galleryFit(); }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { boot(); ticks(); });
  else { boot(); ticks(); }
  setInterval(ticks, 1000);
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); ticks(); });
})();
